import Header from '../components/Header';
import Footer from '../components/Footer';

function TermosDeUso() {
  return (
    <div className="min-h-screen bg-muted/30">
      <Header />
      <main className="max-w-4xl mx-auto px-4 pt-32 pb-16">
        <h1 className="text-3xl md:text-4xl font-bold font-display text-secondary mb-2">Termos de Uso</h1>
        <p className="text-muted-foreground mb-10">Versão 2.0 — Última atualização: Março de 2026</p>

        <div className="bg-card rounded-2xl border border-border p-6 md:p-10 shadow-card space-y-8 text-foreground leading-relaxed">
          <section>
            <h2 className="text-xl font-bold font-display text-secondary mb-3">1. Aceitação dos Termos</h2>
            <p>Ao acessar e utilizar a plataforma QuantoCustaObra, disponível em quantocustaobra.com.br, você declara que leu, compreendeu e concorda com estes Termos de Uso. Se não concordar com qualquer disposição, não utilize a plataforma.</p>
            <p className="mt-2">Estes termos regulam tanto o uso da plataforma em regime de assinatura (planos mensais) quanto a aquisição de produtos digitais avulsos, como o orçamento avulso.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold font-display text-secondary mb-3">2. Descrição do Serviço</h2>
            <p>O QuantoCustaObra é uma plataforma online que fornece estimativas de custos de construção e reforma com base em dados públicos do CUB (Custo Unitário Básico) e SINAPI (Sistema Nacional de Pesquisa de Custos e Índices da Construção Civil).</p>
            <h3 className="font-semibold mt-4 mb-2">2.1 O serviço inclui:</h3>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li>Simulação de custos de construção e reforma</li>
              <li>Cálculos baseados em dados do CUB e SINAPI atualizados mensalmente</li>
              <li>Orçamentos avulsos detalhados (produto digital)</li>
              <li>Relatórios e comparativos (conforme o plano contratado)</li>
              <li>Conteúdo educativo sobre construção civil</li>
            </ul>
            <h3 className="font-semibold mt-4 mb-2">2.2 O serviço NÃO inclui:</h3>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li>Consultoria de engenharia ou arquitetura</li>
              <li>Projetos técnicos</li>
              <li>Orçamento executivo detalhado com ART/RRT</li>
              <li>Responsabilidade técnica (ART/RRT)</li>
              <li>Garantia de exatidão absoluta dos valores</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold font-display text-secondary mb-3">3. Cadastro e Conta</h2>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li>Para utilizar funcionalidades completas, é necessário criar uma conta com informações verdadeiras e atualizadas.</li>
              <li>Você é responsável por manter a confidencialidade da sua senha e por todas as atividades realizadas em sua conta.</li>
              <li>Cada conta é pessoal e intransferível.</li>
              <li>Reservamo-nos o direito de suspender contas que violem estes termos, sem aviso prévio em casos graves.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold font-display text-secondary mb-3">4. Modalidades de Contratação</h2>
            <h3 className="font-semibold mt-4 mb-2">4.1 Plano Gratuito</h3>
            <p className="text-muted-foreground">Acesso limitado conforme descrito na plataforma. Não requer pagamento.</p>

            <h3 className="font-semibold mt-4 mb-2">4.2 Planos de Assinatura (Básico e Profissional)</h3>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li>Cobranças mensais recorrentes via cartão de crédito, boleto bancário ou PIX</li>
              <li>A renovação é automática. O usuário pode cancelar a qualquer momento antes da próxima cobrança</li>
              <li>Preços podem ser alterados com aviso prévio mínimo de 30 dias</li>
              <li>Em caso de inadimplência, o acesso ao plano pago será suspenso, mantendo-se o acesso ao plano gratuito</li>
              <li>Detalhes sobre cancelamento e reembolso constam na Política de Reembolso</li>
            </ul>

            <h3 className="font-semibold mt-4 mb-2">4.3 Orçamento Avulso (Produto Digital)</h3>
            <p className="text-muted-foreground">O orçamento avulso constitui um produto digital de entrega instantânea, nos termos do Art. 49, § 1º do Código de Defesa do Consumidor (Lei nº 8.078/1990) e do Art. 1º, VII do Decreto nº 7.962/2013.</p>
            <p className="mt-2 text-muted-foreground">Ao adquirir um orçamento avulso, o usuário:</p>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li>Recebe acesso imediato ao conteúdo completo do orçamento após a confirmação do pagamento</li>
              <li>Reconhece que o produto digital é entregue de forma instantânea e que, pela sua natureza, não pode ser "devolvido" após a visualização</li>
              <li>Consente expressamente, no ato da compra, com a entrega imediata do conteúdo digital, renunciando ao direito de arrependimento previsto no Art. 49 do CDC para produtos entregues com consentimento expresso do consumidor</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold font-display text-secondary mb-3">5. Aceite Obrigatório para Produto Digital</h2>
            <p className="text-muted-foreground">5.1 Antes de efetuar o pagamento de qualquer orçamento avulso, o usuário deve marcar expressamente a declaração de aceite no formulário de compra.</p>
            <p className="mt-2 text-muted-foreground">5.2 A compra não será processada sem a marcação deste aceite.</p>
            <p className="mt-2 text-muted-foreground">5.3 O registro do aceite (data, hora, IP e identificação do usuário) será armazenado como prova do consentimento expresso, nos termos do Art. 7º, I da LGPD (Lei nº 13.709/2018).</p>
          </section>

          <section>
            <h2 className="text-xl font-bold font-display text-secondary mb-3">6. Registro e Prova de Entrega</h2>
            <h3 className="font-semibold mt-4 mb-2">6.1 Log de Acesso</h3>
            <p className="text-muted-foreground">O QuantoCustaObra registra automaticamente, para cada orçamento gerado:</p>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li>Data e hora da geração do orçamento</li>
              <li>Data e hora de cada visualização subsequente</li>
              <li>Endereço IP do dispositivo utilizado</li>
              <li>Identificação do navegador (user agent)</li>
              <li>Identificação única do usuário e da transação</li>
            </ul>
            <p className="mt-2 text-muted-foreground">6.2 Esses registros constituem prova de entrega do produto digital e serão mantidos pelo prazo mínimo de 5 (cinco) anos, conforme legislação aplicável.</p>
            <h3 className="font-semibold mt-4 mb-2">6.3 Identificação do Documento (Watermark)</h3>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li>Identificação única do documento (código hash)</li>
              <li>Dados do comprador (nome e email) incorporados ao documento</li>
              <li>Data e hora de geração</li>
              <li>Marca d'água digital invisível para rastreamento</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold font-display text-secondary mb-3">7. Uso Adequado da Plataforma</h2>
            <p className="text-muted-foreground">O usuário compromete-se a:</p>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li>Utilizar a plataforma apenas para fins legítimos</li>
              <li>Não reproduzir, distribuir ou comercializar dados ou orçamentos da plataforma</li>
              <li>Não compartilhar orçamentos avulsos adquiridos com terceiros para fins comerciais</li>
              <li>Não tentar acessar áreas restritas do sistema</li>
              <li>Não utilizar robôs, scrapers ou ferramentas automatizadas sem autorização prévia</li>
              <li>Não manipular ou remover marcas d'água ou identificações dos documentos gerados</li>
              <li>Respeitar os limites de simulação do seu plano</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold font-display text-secondary mb-3">8. Propriedade Intelectual</h2>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li>Todo o conteúdo da plataforma (textos, design, código, marca, logotipos, algoritmos de cálculo) é propriedade da QuantoCustaObra ou licenciado para uso.</li>
              <li>Os orçamentos avulsos e relatórios gerados são de uso pessoal ou profissional do usuário adquirente, sendo expressamente vedada a revenda, redistribuição ou publicação sem autorização.</li>
              <li>Os dados do CUB e SINAPI são de domínio público; nosso diferencial protegido está no tratamento, análise, apresentação e metodologia de cálculo aplicados a esses dados.</li>
              <li>A marca "QuantoCustaObra", logotipos e identidade visual são marcas registradas e não podem ser utilizadas sem autorização expressa.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold font-display text-secondary mb-3">9. Limitação de Responsabilidade</h2>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li>Os valores apresentados são <strong>estimativas</strong> baseadas em dados públicos e <strong>não substituem</strong> orçamento profissional detalhado elaborado por engenheiro ou arquiteto habilitado.</li>
              <li>O QuantoCustaObra não se responsabiliza por decisões financeiras, contratuais ou de qualquer natureza tomadas exclusivamente com base nas estimativas da plataforma.</li>
              <li>Recomendamos fortemente a contratação de profissionais habilitados (engenheiros e arquitetos) para a execução de obras e reformas.</li>
              <li>Nossa responsabilidade total está limitada ao valor efetivamente pago pelo usuário nos últimos 12 meses.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold font-display text-secondary mb-3">10. Garantia e Reembolso</h2>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li>Orçamento Avulso (Produto Digital): A política de reembolso para orçamentos avulsos é diferenciada em razão da natureza de entrega instantânea do produto. Consulte a <a href="/politica-de-reembolso" className="text-accent hover:underline">Política de Reembolso</a> para regras específicas.</li>
              <li>Planos de Assinatura: O cancelamento pode ser realizado a qualquer momento. Consulte a Política de Reembolso para detalhes sobre estornos e prazos.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold font-display text-secondary mb-3">11. Privacidade e Proteção de Dados</h2>
            <p className="text-muted-foreground">O tratamento de dados pessoais é regido pela nossa Política de Privacidade, em conformidade com a LGPD (Lei nº 13.709/2018). Os logs de acesso descritos na Seção 6 são coletados com base no legítimo interesse do controlador (Art. 7º, IX da LGPD) para fins de prova de entrega e prevenção de fraude.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold font-display text-secondary mb-3">12. Modificações dos Termos</h2>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li>Podemos alterar estes termos a qualquer momento.</li>
              <li>Alterações significativas serão comunicadas por email e/ou aviso na plataforma com antecedência mínima de 30 dias.</li>
              <li>O uso continuado da plataforma após o período de notificação constitui aceitação dos novos termos.</li>
              <li>Caso não concorde com as alterações, o usuário pode encerrar sua conta antes da entrada em vigor dos novos termos.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold font-display text-secondary mb-3">13. Rescisão</h2>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li>Você pode encerrar sua conta a qualquer momento através das configurações da conta ou por email.</li>
              <li>Reservamo-nos o direito de encerrar contas que violem estes termos, sem aviso prévio em casos graves (fraude, abuso, violação de propriedade intelectual).</li>
              <li>Orçamentos avulsos já adquiridos e visualizados permanecem disponíveis para download por 90 dias após o encerramento da conta.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold font-display text-secondary mb-3">14. Disposições Gerais</h2>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li>Estes termos são regidos pelas leis da República Federativa do Brasil.</li>
              <li>Fica eleito o Foro da Comarca de Belo Horizonte, Estado de Minas Gerais, para dirimir eventuais disputas decorrentes destes termos.</li>
              <li>A invalidade ou inaplicabilidade de qualquer cláusula não afeta a validade das demais disposições.</li>
              <li>Estes Termos de Uso, juntamente com a Política de Privacidade e a Política de Reembolso, constituem o acordo integral entre o usuário e o QuantoCustaObra.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold font-display text-secondary mb-3">15. Contato</h2>
            <p className="text-muted-foreground">QuantoCustaObra Tecnologia Ltda.</p>
            <ul className="list-none space-y-1 text-muted-foreground mt-2">
              <li>Email geral: contato@quantocustaobra.com.br</li>
              <li>Financeiro: financeiro@quantocustaobra.com.br</li>
              <li>Privacidade: privacidade@quantocustaobra.com.br</li>
              <li>Site: quantocustaobra.com.br</li>
            </ul>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default TermosDeUso;
